export default function About() {
  return (
    <section className="font-mono text-sm leading-[1.7] text-black">
      {/* <p> */}
        {/* I'm an AI engineer focused on production ML systems. */}
      {/* </p> */}
      <p className="mt-3">
        I’m an AI engineer focused on building production ML systems and automations.
        I majored in electronics and spent a couple of years studying Data Science at IIT Madras alongside. 
        </p>
      <p className="mt-3">
        I recently got to be part of an AI Launchpad cohort in the Himalayas, where I spent a few months building and shipping things.
      </p>
      <p className="mt-3">
        Outside of work, you’ll find me playing board games, jamming, running, or just hanging out.
        I’ve got a long list of sports to learn, instruments to play, and places to explore :) 
     </p>
    </section>
  );
}
